import React from 'react';
import PropTypes from 'prop-types';

import RenderEventInvitation from './RenderEventInvitation';

function RenderEventInvitations({ fields, id, label, hideFormGroup, meta: { touched, error }, eventFormValues, handleEventInvitation, disabled }) {
  return (
    <div className={`${hideFormGroup ? '' : 'form-group'} ${disabled ? 'event-invitations-disabled' : ''} ${touched && error ? 'has-error' : ''}`}>
      <label htmlFor={id} className="margin-right-2x">{label}</label>
      <div id={id} className="visible-xs-inline visible-sm-inline visible-md-inline visible-lg-inline">
        {fields.map((eventInvitation, index, fieldsRef) => (
          <RenderEventInvitation
            key={index}
            eventInvitation={eventInvitation}
            index={index}
            fields={fieldsRef}
            eventFormValues={eventFormValues}
            handleEventInvitation={handleEventInvitation}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
}

RenderEventInvitations.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  hideFormGroup: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  eventFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  handleEventInvitation: PropTypes.func,
  disabled: PropTypes.bool,
};

export default RenderEventInvitations;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/RenderEventInvitations.jsx